import React from 'react';
import ProposalFreeLayout from './ProposalFreeLayout';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';

const proposalFreeLayoutConfig = {
  label: 'Mise en page libre',
  defaultProps: { canvasWidth: 825, minHeight: 240, marginBottom: '', items: [] },
  fields: {
    minHeight: { type: 'number', label: 'Hauteur minimale (px)', min: 80, max: 4000 },
    marginBottom: puckPxSpacingField('Espace sous la section'),
  },
  render: ({ id, canvasWidth, minHeight, marginBottom, items }) => (
    <ProposalFreeLayout
      id={id}
      canvasWidth={canvasWidth}
      minHeight={minHeight}
      marginBottom={marginBottom}
      items={items}
    />
  ),
};

export default proposalFreeLayoutConfig;
